export default "__VITE_ASSET__jTFOUVJm__"